var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resourceEmpty"},[_c('div',{staticClass:"resourceEmptyTitle"},[_c('img',{attrs:{"src":require("@/assets/image/resource-no-data.png"),"alt":"请选择本地资源上传"}}),_c('span',[_vm._v("请选择本地资源上传")])])])
}]

export { render, staticRenderFns }